import React from 'react'
import * as L from 'react-leaflet'
import leaflet from 'leaflet'
import {getIcon} from 'common/Map/POI'
import _ from 'lodash'

const getLeafletIcon = _.memoize(iconSpec => leaflet.icon(iconSpec))

// DEPRECATED - compability layer for regional embeds
export class POIMarker extends React.PureComponent {
  onPopupOpen = () => {
    this._tooltip && this._tooltip.leafletElement.setOpacity(0)
  }

  onPopupClose = () => {
    this._tooltip && this._tooltip.leafletElement.setOpacity(0.9)
  }

  render () {
    const {poi, children, ...props} = this.props
    const leafletIcon = getLeafletIcon(getIcon(poi.t))

    return (
      <L.Marker icon={leafletIcon} position={poi} onPopupOpen={this.onPopupOpen} onPopupClose={this.onPopupClose} {...props}>
        <L.Tooltip ref={r => { this._tooltip = r }} direction='top' offset={[0, -37]}>
          <span>{poi.n}</span>
        </L.Tooltip>
        {children}
      </L.Marker>
    )
  }
}
